import { apiClient } from "../api/client";

// Admin price-table writes (Generic items, Ink prices, Curated prices) through
// the backend's audited CRUD routes: POST `endpoint`, PUT/DELETE
// `endpoint/:id`. Each resolves to the response body.

export const createAdminRow = async (endpoint: string, data: unknown) => (await apiClient.post(endpoint, data)).data;

export const updateAdminRow = async (endpoint: string, id: number, data: unknown) =>
  (await apiClient.put(`${endpoint}/${id}`, data)).data;

export const deleteAdminRow = async (endpoint: string, id: number) => (await apiClient.delete(`${endpoint}/${id}`)).data;
